import React from 'react'
import { useTranslation } from 'react-i18next'
import { useContact } from '../../context/ContactContext'
import './services.css'
import { BiCodeAlt, BiGlobe, BiDesktop, BiMobile } from 'react-icons/bi'
import { FiArrowUpRight } from 'react-icons/fi'

const Services = () => {
  const { t } = useTranslation()
  const { openContact } = useContact()

  const services = [
    { key: 'appDev', icon: BiCodeAlt, accent: '#8b5cf6' },
    { key: 'webDev', icon: BiGlobe, accent: '#a78bfa' },
    { key: 'website', icon: BiDesktop, accent: '#7c3aed' },
    { key: 'mobile', icon: BiMobile, accent: '#c4b5fd' },
  ]

  return (
    <section id="services" className="services-section">
      <div className="services-section__glow" />
      <div className="container">
        <div className="section__header">
          <span className="section__label">{t('services.subtitle')}</span>
          <h2 className="section__title">{t('services.title')}</h2>
        </div>

        <div className="services__grid">
          {services.map(({ key, icon: Icon, accent }, index) => (
            <article
              key={key}
              className="service glass"
              style={{ '--service-accent': accent }}
            >
              <span className="service__index">{String(index + 1).padStart(2, '0')}</span>

              <div className="service__head">
                <div className="service__icon">
                  <Icon />
                </div>
                <h3>{t(`services.${key}.title`)}</h3>
              </div>

              <p className="service__desc">{t(`services.${key}.p1`)}</p>

              <ul className="service__points">
                <li>{t(`services.${key}.p2`)}</li>
                <li>{t(`services.${key}.p3`)}</li>
              </ul>

              <button type="button" className="service__link" onClick={openContact}>
                {t('nav.contact')} <FiArrowUpRight />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
